import { render, staticRenderFns } from "./PurchaseSuccessDialog.vue?vue&type=template&id=2e817e2c&scoped=true"
import script from "./PurchaseSuccessDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSuccessDialog.vue?vue&type=style&index=0&id=2e817e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e817e2c",
  null
  
)

export default component.exports